var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.noticeExists)?_c('div',{attrs:{"id":"notice"}},[_c('div',{staticClass:"notice-inner container vertical-center column-sm"},[_c('img',{attrs:{"src":_vm.renderImage(_vm.currentNotice.image),"alt":""}}),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.currentNotice.text))])])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }